import React from "react";

const Check = () => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" data-testid="check-icon">
      <defs>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="check_icon_prefix__a"
        >
          <feColorMatrix
            values="0 0 0 0 0.163091923 0 0 0 0 0.345165308 0 0 0 0 0.284910807 0 0 0 0.321213942 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path
          d="M7.71 11.296a1 1 0 00-1.42 1.408l3.963 4a1 1 0 001.51-.104l5.99-8a1 1 0 00-1.6-1.2l-5.295 7.073-3.148-3.177z"
          id="check_icon_prefix__b"
        />
      </defs>
      <g filter="url(#check_icon_prefix__a)" fill="none" fillRule="evenodd">
        <circle fill="#00C2A3" cx={12} cy={12} r={10} />
        <path d="M0 0h24v24H0z" />
        <mask id="check_icon_prefix__c" fill="#fff">
          <use xlinkHref="#check_icon_prefix__b" />
        </mask>
        <use
          ffill="#00C2A3"
          fillRule="nonzero"
          xlinkHref="#check_icon_prefix__b"
        />
        <g mask="url(#check_icon_prefix__c)" fill="#FFF">
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
};

export default Check;
